import React, { useEffect, useState } from 'react';
import { Text, HStack, useTheme } from 'native-base';
import { useEditPostState } from '../../../context/edit';
const ReplyCounter = ({
  topicId,
  posts_count
}) => {
  const theme = useTheme();
  // camel case is state variable (and gets updated as necessary), serpent case is from passed-down prop
  const [postCount, setPostCount] = useState(posts_count);
  const {
    postUpdated
  } = useEditPostState();
  useEffect(() => {
    /* if this value has changed, it's because
     * the logged-in user has made a new post
     * we need to increment the posts_count here
     * without making an API call to get the full topic
     * Another component will handle updating postUpdated to not contain topicId */
    if (postUpdated.topicId === topicId) {
      setPostCount(prevCount => prevCount + 1);
    }
  }, [postUpdated]);
  return /*#__PURE__*/React.createElement(HStack, {
    alignItems: 'center'
  }, /*#__PURE__*/React.createElement(Text, null, postCount > 1 ? `${postCount - 1} ${postCount > 2 ? 'replies' : 'reply'}` : 'No replies', " "));
};
export default ReplyCounter;
//# sourceMappingURL=ReplyCounter.js.map